<div class="modal fade" id="updateUserForm" tabindex="-1" role="dialog" aria-labelledby="updateUserForm" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content container">
      <div class="modal-header">
        @if (iStudent) {
          <h3 class="modal-title" id="updateUserFormTitle" name="startAt">
            MODIFIER LE MOT DE PASSE - # {{iStudent.lastname}} {{iStudent.firstname}}
          </h3>
        }
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      @if (popupError && popupError.length > 0) {
        <div id="newPaymentError" class="alert alert-danger mt-4 ms-4 me-4" role="alert">
          ERREUR : {{popupError}}
        </div>
      }

      @if (!isSuccessful) {
        <form name="form" (ngSubmit)="f.form.valid && onSubmit()"
          #f="ngForm" novalidate>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" class="form-control" name="email" [(ngModel)]="form.email"
              required email #email="ngModel" disabled/>
            @if (email.errors && f.submitted) {
              <div class="alert-danger">
                @if (email.errors.required) {
                  <div>Email is required</div>
                }
                @if (email.errors.email) {
                  <div>
                    Email must be a valid email address
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" id="username" class="form-control" name="username" [(ngModel)]="form.username"
              required minlength="3" maxlength="20" #username="ngModel"/>
            @if (username.errors && f.submitted) {
              <div class="alert-danger">
                @if (username.errors.required) {
                  <div>Username is required</div>
                }
                @if (username.errors.minlength) {
                  <div>
                    Username must be at least 3 characters
                  </div>
                }
                @if (username.errors.maxlength) {
                  <div>
                    Username must be at most 20 characters
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" id="password" class="form-control" name="password" [(ngModel)]="form.password"
              required minlength="6" #password="ngModel"/>
            @if (password.errors && f.submitted) {
              <div class="alert-danger">
                @if (password.errors.required) {
                  <div>Password is required</div>
                }
                @if (password.errors.minlength) {
                  <div>
                    Password must be at least 6 characters
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block">VALIDER</button>
          </div>
          @if (f.submitted && isSignUpFailed) {
            <div class="alert alert-warning">
              Une erreur a été rencontrée : <br />{{ errorMessage }}
            </div>
          }
        </form>
      }

      @if (isSuccessful) {
        <div class="alert alert-success">
          Le mot de passe a été modifié !
        </div>
      }



    </div>
  </div>
</div>
